module.exports = __webpack_public_path__ + "img/onewood2.db150b73.png";